import React, { useEffect, useState } from "react";
import axios from "axios";

const FeeDataComponent = () => {
  const [feeData, setFeeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeeData = async () => {
      try {
        const response = await axios.get("/fees/fetch-fee-records");
        setFeeData(response.data.data);
        // Log the data to console as requested
        setLoading(false);
      } catch (error) {
        console.error("Error fetching fee data:", error);
        setError("Failed to fetch fee records");
        setLoading(false);
      }
    };

    fetchFeeData();
  }, []);

  // This component doesn't render anything visible
  // It just fetches and logs the data to console
  return null;
};

export default FeeDataComponent;
